// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
    display: flex;
    
    font-family: Arial, sans-serif;
    background-color: #f4f4f9;
    padding-top: 110px;
}

.sidebar {
    width:20%;
    min-width: 250px;
    background-color: #2c3e50;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.sidebar button {
    width: 90%;
    padding: 15px;
    margin: 10px 0;
    background-color: #34495e;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.sidebar button:hover {
    background-color: #1abc9c;
}

.content {
    flex-grow: 1;
    padding: 20px;
}

.admin-dashboard .table-container {
    max-width: 75%;
    margin-top: 0px;
    height:100%;
    margin-left: 0px;
    margin-right: auto;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    
    display: flex;
    flex-direction: column;
    
    
   
}

.table-container h2 {

    text-align: center;
    padding: 10px;
    color: #333;
}

.order-table {
    width: 95%;
    border-collapse: collapse;
    margin: 20px;
    display: block;
    overflow-x: scroll;
}

.order-table thead {
    background-color: #f1f3f5;
    
}

.order-table th,
.order-table td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
    min-width: 300px;
}

.order-table th {
    font-weight: 600;
}

.order-table tr:hover {
    background-color: #f1f1f1;
}

.order-table tr:nth-child(even) {
    background-color: #f9f9f9;
}

.table-container label{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 'Poppins',sans-serif;

}
.table-container label input{
    width:20px;
    height:20px;
}

.manage-slides-container{
    display: flex;
    flex-direction: column;
    width:90%;
    align-items: center;
    justify-content: center;
}

.manage-slides-content{
    display: flex;
    flex-direction: row;
}
.manage-slides-content ul{
    width:100%;
    list-style-type: none;
    
}

.manage-slides-content ul li{
    padding: 10px;
    margin: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:300px;
}
.manage-slides-content ul li h3{
    font-family: 'Poppins',sans-serif;
    font-weight: 500;
    font-size: 16px;

}

.manage-slides-content ul li img{
    width:150px;
}

.manage-slides-container ul li button{
    width:150px;
    height:40px;
    background-color: #e42727;
    color:#fff;
    border-radius: 5px;
    margin: 10px;
    cursor: pointer;
}

.manage-slides-container ul li button:hover {
    background-color: #ffa406;
}

.manage-slides-container form{
    width:600px;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.manage-slides-container label {
    width: 100px;
    text-align: left;
    margin-right: 20px;
    font-family: 'Poppins',sans-serif;
}
.manage-slides-container form input,textarea{
    width: 300px;
}
.manage-slides-container form button{
    width: 150px;
    height:40px;
    background-color: #e42727;
    color:#fff;
    border-radius: 5px;
    cursor: pointer;
}

.manage-slides-container form button:hover{
    background-color: #ffa406;
    
}

.slider-update-input{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.add-job {
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
}
.add-job form{
    width:60%;
    height:80%;
}
.add-job input{
    margin-right: 0px;
    margin:10px 0px;
    height:40px;
}
.add-job textarea{
    width:99.6%;
    height:300px;
    margin-bottom: 10px;

}

.add-job button{
    height:40px;
    background-color: #e42727;
    font-family: 'Poppins',sans-serif;
    font-size: 16px;
    cursor: pointer;
}

.delete-job{
    width:80%;
    display: flex;
    flex-direction: column;
    height:100%;
    align-items: center;
}

.delete-job select{
    width:400px;
    height:40px;
    margin-bottom: 10px;
}

.delete-job button{
    width:150px;
    height:50px;
    color:#fff;
    background-color: #e42727;
    cursor: pointer;

}

.delete-job button:hover{
    background-color: #ffa406;
}

.mobile-navbar-links{
    display: none;
}


.admin-toggle {
    display: flex;
    flex-direction: column;
    justify-content:flex-start;
    align-items: center;
    gap: 20px;
    position: absolute;
    top:180px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.shipping-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e42727;
    transition: 0.4s;
    border-radius: 34px;
}

.shipping-slider:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: #e42727;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked+.shipping-slider {
    background-color: #4caf50;
}

input:checked+.shipping-slider:before {
    transform: translateX(26px);
}

.date-filter-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    /* Space between elements */
    align-items: center;
    justify-content: flex-start;
    margin: 16px 0;
    padding: 16px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.date-filter-container label {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-right: 8px;
}

.date-filter-container input[type="date"] {
    width:100%;
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    outline: none;
    transition: border-color 0.3s ease;
}

.date-filter-container input[type="date"]:focus {
    border-color: #007bff;
}

.date-filter-container button {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.date-filter-container button:hover {
    background-color: #0056b3;
}

.date-filter-container button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.admin__dashboard__orders___page__number{
    cursor:pointer;
    font-size: large;
        padding: 10px;
        cursor: pointer;
    
}

@media (max-width: 768px) {
    .date-filter-container {
        flex-direction: column;
        align-items: stretch;
    }

    .date-filter-container input[type="date"],
    .date-filter-container button {
        width: 100%;
    }
}
@media screen and (max-width:768px){
    .admin-dashboard {
            display: flex;
            flex-direction: column;
            min-height: 100%;
            font-family: Arial, sans-serif;
            background-color: #f4f4f9;
            padding-top: 160px;
        }

        .content{
            padding:0px;
        }
    .table-container h2 {
            text-align: center;
            
            color: #333;
        }
        .sidebar {
            display: none;
        }
        .sidebar button {
            width: 20%;
            padding: 15px;
            margin: 10px 0;
            background-color: #34495e;
            color: #fff;
            border: none;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            transition: background-color 0.3s;
        }
    
        .sidebar button:hover {
            background-color: #1abc9c;
        }
        .mobile-navbar-links {
            display: flex;
        }
        .mobile-nav-links.open{
            background-color: #fff;
            height:100%;
            width:80%;
           
            margin:20px 10% ;
            display: flex;
                flex-direction: column;
                
                height: fit-content;
            
            
                z-index: 1;
                background-color: #FFF;
                
              
           
        }
        .mobile-nav-links.open button{
            background-color: #fff;
            width: 50%;
            padding:5px;
            margin:0 auto;
            text-align: left;
            font-family: 'Poppins',sans-serif;
            font-size: 18px;
        }
        .admin-dashboard .table-container{
            max-width:100%;
            width:100%;
            margin:20px auto;
            padding:10px;
        }
        .dashboard-filter-container{
            display: flex;
            flex-direction: column;
            gap:10px;
        }
        .order-table{
          margin:10px;
        }
        .order-table tr {
             display: flex;
             box-sizing: border-box;
    
    
    
         }
    
         .order-table th,
         .order-table td {
             width: 400px;
             margin:0px;
             box-sizing: border-box;
         }

         .dashboard-pagination button{
            margin-bottom:0px;
         }
        .add-job form {
            width: 80%;
            height: 80%;
        }
        .delete-job {
            width: 100%;
            display: flex;
            flex-direction: column;
            height: 100%;
            align-items: center;
        }
        .delete-job select {
            width: 80%;
            height: 40px;
            margin-bottom: 10px;
        }
        .manage-slides-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width:100%;
            margin:20px auto;
        }
        .manage-slides-container form {
            width:100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin:20px auto;
        }
         .manage-slides-container label {
             width: 20%;
             text-align: left;
             margin-right: 20px;
             font-family: 'Poppins', sans-serif;
             font-size: 16px;
         }
    
         .manage-slides-container form input,
         .manage-slides-container form textarea {
             width: 60%;
         }
    
         .manage-slides-container form button {
             width: 150px;
             height: 40px;
             background-color: #e42727;
             color: #fff;
             border-radius: 5px;
             cursor: pointer;
         }
        .manage-slides-content ul {
            width: 100%;
            list-style-type: none;
            padding-left: 0px;
    
        }
    
        .manage-slides-content ul li {
            padding: 10px;
            margin: 10px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
        }
    
        .manage-slides-content ul li h3 {
            font-family: 'Poppins', sans-serif;
            font-weight: 500;
            font-size: 16px;
    
        }
    
        .manage-slides-content ul li img {
            width: 60%;
        }
    
        .manage-slides-container ul li button {
            width: 150px;
            height: 40px;
            background-color: #e42727;
            color: #fff;
            border-radius: 5px;
            margin: 10px;
            cursor: pointer;
        }
    
        .manage-slides-container ul li button:hover {
            background-color: #ffa406;
        }
        .slider-update-input {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width:100%;
        }
        
}`, "",{"version":3,"sources":["webpack://./src/Styles/AdminDashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;;IAEb,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;;IAExC,aAAa;IACb,sBAAsB;;;;AAI1B;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iCAAiC;;AAErC;AACA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;AACd;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iCAAiC;IACjC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,eAAe;;AAEnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;QACZ,aAAa;QACb,eAAe;;AAEvB;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;QAEI,WAAW;IACf;AACJ;AACA;IACI;YACQ,aAAa;YACb,sBAAsB;YACtB,gBAAgB;YAChB,8BAA8B;YAC9B,yBAAyB;YACzB,kBAAkB;QACtB;;QAEA;YACI,WAAW;QACf;IACJ;YACQ,kBAAkB;;YAElB,WAAW;QACf;QACA;YACI,aAAa;QACjB;QACA;YACI,UAAU;YACV,aAAa;YACb,cAAc;YACd,yBAAyB;YACzB,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,eAAe;YACf,eAAe;YACf,iCAAiC;QACrC;;QAEA;YACI,yBAAyB;QAC7B;QACA;YACI,aAAa;QACjB;QACA;YACI,sBAAsB;YACtB,WAAW;YACX,SAAS;;YAET,gBAAgB;YAChB,aAAa;gBACT,sBAAsB;;gBAEtB,mBAAmB;;;gBAGnB,UAAU;gBACV,sBAAsB;;;;QAI9B;QACA;YACI,sBAAsB;YACtB,UAAU;YACV,WAAW;YACX,aAAa;YACb,gBAAgB;YAChB,iCAAiC;YACjC,eAAe;QACnB;QACA;YACI,cAAc;YACd,UAAU;YACV,gBAAgB;YAChB,YAAY;QAChB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,QAAQ;QACZ;QACA;UACE,WAAW;QACb;QACA;aACK,aAAa;aACb,sBAAsB;;;;SAI1B;;SAEA;;aAEI,YAAY;aACZ,UAAU;aACV,sBAAsB;SAC1B;;SAEA;YACG,iBAAiB;SACpB;QACD;YACI,UAAU;YACV,WAAW;QACf;QACA;YACI,WAAW;YACX,aAAa;YACb,sBAAsB;YACtB,YAAY;YACZ,mBAAmB;QACvB;QACA;YACI,UAAU;YACV,YAAY;YACZ,mBAAmB;QACvB;QACA;YACI,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,UAAU;YACV,gBAAgB;QACpB;QACA;YACI,UAAU;YACV,aAAa;YACb,sBAAsB;YACtB,mBAAmB;YACnB,uBAAuB;YACvB,gBAAgB;QACpB;SACC;aACI,UAAU;aACV,gBAAgB;aAChB,kBAAkB;aAClB,kCAAkC;aAClC,eAAe;SACnB;;SAEA;;aAEI,UAAU;SACd;;SAEA;aACI,YAAY;aACZ,YAAY;aACZ,yBAAyB;aACzB,WAAW;aACX,kBAAkB;aAClB,eAAe;SACnB;QACD;YACI,WAAW;YACX,qBAAqB;YACrB,iBAAiB;;QAErB;;QAEA;YACI,aAAa;YACb,YAAY;YACZ,uCAAuC;YACvC,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,mBAAmB;YACnB,WAAW;QACf;;QAEA;YACI,kCAAkC;YAClC,gBAAgB;YAChB,eAAe;;QAEnB;;QAEA;YACI,UAAU;QACd;;QAEA;YACI,YAAY;YACZ,YAAY;YACZ,yBAAyB;YACzB,WAAW;YACX,kBAAkB;YAClB,YAAY;YACZ,eAAe;QACnB;;QAEA;YACI,yBAAyB;QAC7B;QACA;YACI,aAAa;YACb,mBAAmB;YACnB,8BAA8B;YAC9B,mBAAmB;YACnB,UAAU;QACd;;AAER","sourcesContent":[".admin-dashboard {\n    display: flex;\n    \n    font-family: Arial, sans-serif;\n    background-color: #f4f4f9;\n    padding-top: 110px;\n}\n\n.sidebar {\n    width:20%;\n    min-width: 250px;\n    background-color: #2c3e50;\n    padding-top: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.sidebar button {\n    width: 90%;\n    padding: 15px;\n    margin: 10px 0;\n    background-color: #34495e;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.sidebar button:hover {\n    background-color: #1abc9c;\n}\n\n.content {\n    flex-grow: 1;\n    padding: 20px;\n}\n\n.admin-dashboard .table-container {\n    max-width: 75%;\n    margin-top: 0px;\n    height:100%;\n    margin-left: 0px;\n    margin-right: auto;\n    background-color: #fff;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    \n    display: flex;\n    flex-direction: column;\n    \n    \n   \n}\n\n.table-container h2 {\n\n    text-align: center;\n    padding: 10px;\n    color: #333;\n}\n\n.order-table {\n    width: 95%;\n    border-collapse: collapse;\n    margin: 20px;\n    display: block;\n    overflow-x: scroll;\n}\n\n.order-table thead {\n    background-color: #f1f3f5;\n    \n}\n\n.order-table th,\n.order-table td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n    font-size: 14px;\n    min-width: 300px;\n}\n\n.order-table th {\n    font-weight: 600;\n}\n\n.order-table tr:hover {\n    background-color: #f1f1f1;\n}\n\n.order-table tr:nth-child(even) {\n    background-color: #f9f9f9;\n}\n\n.table-container label{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 'Poppins',sans-serif;\n\n}\n.table-container label input{\n    width:20px;\n    height:20px;\n}\n\n.manage-slides-container{\n    display: flex;\n    flex-direction: column;\n    width:90%;\n    align-items: center;\n    justify-content: center;\n}\n\n.manage-slides-content{\n    display: flex;\n    flex-direction: row;\n}\n.manage-slides-content ul{\n    width:100%;\n    list-style-type: none;\n    \n}\n\n.manage-slides-content ul li{\n    padding: 10px;\n    margin: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width:300px;\n}\n.manage-slides-content ul li h3{\n    font-family: 'Poppins',sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n\n}\n\n.manage-slides-content ul li img{\n    width:150px;\n}\n\n.manage-slides-container ul li button{\n    width:150px;\n    height:40px;\n    background-color: #e42727;\n    color:#fff;\n    border-radius: 5px;\n    margin: 10px;\n    cursor: pointer;\n}\n\n.manage-slides-container ul li button:hover {\n    background-color: #ffa406;\n}\n\n.manage-slides-container form{\n    width:600px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.manage-slides-container label {\n    width: 100px;\n    text-align: left;\n    margin-right: 20px;\n    font-family: 'Poppins',sans-serif;\n}\n.manage-slides-container form input,textarea{\n    width: 300px;\n}\n.manage-slides-container form button{\n    width: 150px;\n    height:40px;\n    background-color: #e42727;\n    color:#fff;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.manage-slides-container form button:hover{\n    background-color: #ffa406;\n    \n}\n\n.slider-update-input{\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.add-job {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width:100%;\n}\n.add-job form{\n    width:60%;\n    height:80%;\n}\n.add-job input{\n    margin-right: 0px;\n    margin:10px 0px;\n    height:40px;\n}\n.add-job textarea{\n    width:99.6%;\n    height:300px;\n    margin-bottom: 10px;\n\n}\n\n.add-job button{\n    height:40px;\n    background-color: #e42727;\n    font-family: 'Poppins',sans-serif;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.delete-job{\n    width:80%;\n    display: flex;\n    flex-direction: column;\n    height:100%;\n    align-items: center;\n}\n\n.delete-job select{\n    width:400px;\n    height:40px;\n    margin-bottom: 10px;\n}\n\n.delete-job button{\n    width:150px;\n    height:50px;\n    color:#fff;\n    background-color: #e42727;\n    cursor: pointer;\n\n}\n\n.delete-job button:hover{\n    background-color: #ffa406;\n}\n\n.mobile-navbar-links{\n    display: none;\n}\n\n\n.admin-toggle {\n    display: flex;\n    flex-direction: column;\n    justify-content:flex-start;\n    align-items: center;\n    gap: 20px;\n    position: absolute;\n    top:180px;\n}\n\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 34px;\n}\n\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n.shipping-slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #e42727;\n    transition: 0.4s;\n    border-radius: 34px;\n}\n\n.shipping-slider:before {\n    position: absolute;\n    content: '';\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: #e42727;\n    transition: 0.4s;\n    border-radius: 50%;\n}\n\ninput:checked+.shipping-slider {\n    background-color: #4caf50;\n}\n\ninput:checked+.shipping-slider:before {\n    transform: translateX(26px);\n}\n\n.date-filter-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    /* Space between elements */\n    align-items: center;\n    justify-content: flex-start;\n    margin: 16px 0;\n    padding: 16px;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.date-filter-container label {\n    font-size: 14px;\n    font-weight: bold;\n    color: #333;\n    margin-right: 8px;\n}\n\n.date-filter-container input[type=\"date\"] {\n    width:100%;\n    padding: 8px;\n    font-size: 14px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    outline: none;\n    transition: border-color 0.3s ease;\n}\n\n.date-filter-container input[type=\"date\"]:focus {\n    border-color: #007bff;\n}\n\n.date-filter-container button {\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: bold;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.date-filter-container button:hover {\n    background-color: #0056b3;\n}\n\n.date-filter-container button:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n}\n\n.admin__dashboard__orders___page__number{\n    cursor:pointer;\n    font-size: large;\n        padding: 10px;\n        cursor: pointer;\n    \n}\n\n@media (max-width: 768px) {\n    .date-filter-container {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .date-filter-container input[type=\"date\"],\n    .date-filter-container button {\n        width: 100%;\n    }\n}\n@media screen and (max-width:768px){\n    .admin-dashboard {\n            display: flex;\n            flex-direction: column;\n            min-height: 100%;\n            font-family: Arial, sans-serif;\n            background-color: #f4f4f9;\n            padding-top: 160px;\n        }\n\n        .content{\n            padding:0px;\n        }\n    .table-container h2 {\n            text-align: center;\n            \n            color: #333;\n        }\n        .sidebar {\n            display: none;\n        }\n        .sidebar button {\n            width: 20%;\n            padding: 15px;\n            margin: 10px 0;\n            background-color: #34495e;\n            color: #fff;\n            border: none;\n            border-radius: 5px;\n            font-size: 16px;\n            cursor: pointer;\n            transition: background-color 0.3s;\n        }\n    \n        .sidebar button:hover {\n            background-color: #1abc9c;\n        }\n        .mobile-navbar-links {\n            display: flex;\n        }\n        .mobile-nav-links.open{\n            background-color: #fff;\n            height:100%;\n            width:80%;\n           \n            margin:20px 10% ;\n            display: flex;\n                flex-direction: column;\n                \n                height: fit-content;\n            \n            \n                z-index: 1;\n                background-color: #FFF;\n                \n              \n           \n        }\n        .mobile-nav-links.open button{\n            background-color: #fff;\n            width: 50%;\n            padding:5px;\n            margin:0 auto;\n            text-align: left;\n            font-family: 'Poppins',sans-serif;\n            font-size: 18px;\n        }\n        .admin-dashboard .table-container{\n            max-width:100%;\n            width:100%;\n            margin:20px auto;\n            padding:10px;\n        }\n        .dashboard-filter-container{\n            display: flex;\n            flex-direction: column;\n            gap:10px;\n        }\n        .order-table{\n          margin:10px;\n        }\n        .order-table tr {\n             display: flex;\n             box-sizing: border-box;\n    \n    \n    \n         }\n    \n         .order-table th,\n         .order-table td {\n             width: 400px;\n             margin:0px;\n             box-sizing: border-box;\n         }\n\n         .dashboard-pagination button{\n            margin-bottom:0px;\n         }\n        .add-job form {\n            width: 80%;\n            height: 80%;\n        }\n        .delete-job {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            align-items: center;\n        }\n        .delete-job select {\n            width: 80%;\n            height: 40px;\n            margin-bottom: 10px;\n        }\n        .manage-slides-content {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            width:100%;\n            margin:20px auto;\n        }\n        .manage-slides-container form {\n            width:100%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            margin:20px auto;\n        }\n         .manage-slides-container label {\n             width: 20%;\n             text-align: left;\n             margin-right: 20px;\n             font-family: 'Poppins', sans-serif;\n             font-size: 16px;\n         }\n    \n         .manage-slides-container form input,\n         .manage-slides-container form textarea {\n             width: 60%;\n         }\n    \n         .manage-slides-container form button {\n             width: 150px;\n             height: 40px;\n             background-color: #e42727;\n             color: #fff;\n             border-radius: 5px;\n             cursor: pointer;\n         }\n        .manage-slides-content ul {\n            width: 100%;\n            list-style-type: none;\n            padding-left: 0px;\n    \n        }\n    \n        .manage-slides-content ul li {\n            padding: 10px;\n            margin: 10px;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            width: 100%;\n        }\n    \n        .manage-slides-content ul li h3 {\n            font-family: 'Poppins', sans-serif;\n            font-weight: 500;\n            font-size: 16px;\n    \n        }\n    \n        .manage-slides-content ul li img {\n            width: 60%;\n        }\n    \n        .manage-slides-container ul li button {\n            width: 150px;\n            height: 40px;\n            background-color: #e42727;\n            color: #fff;\n            border-radius: 5px;\n            margin: 10px;\n            cursor: pointer;\n        }\n    \n        .manage-slides-container ul li button:hover {\n            background-color: #ffa406;\n        }\n        .slider-update-input {\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            align-items: center;\n            width:100%;\n        }\n        \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
